/*
 * EditAdlTooltip Messages
 *
 * This contains all the text for the EditAdlTooltip container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.EditAdlTooltip';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Edit advanced logic',
  },
  titleWithQuotas: {
    id: `${scope}.titleWithQuotas`,
    defaultMessage: 'Edit advanced logic & quotas',
  },
  body: {
    id: `${scope}.body`,
    defaultMessage:
      'You can make changes to the advanced skip logic and adjust your questionnaire sequence or modify how you screen out respondents.',
  },
  bodyQuota: {
    id: `${scope}.bodyQuota`,
    defaultMessage: 'You can also edit answers quota.',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Close',
  },
  doNotShow: {
    id: `${scope}.doNotShow`,
    defaultMessage: "Don't show this again",
  },
});
